import styled from 'styled-components';
import { primary, secondary } from '../../App/theme';

export const Card = styled.div`
  border: 1px solid ${secondary.main};
  box-sizing: border-box;
  border-radius: 25px;
  width: 25vw;
  padding: 1vw;
  margin-left: 1vw;
  margin-right: 2vw;
  display: flex;
  flex-direction: column;
  margin-top: 6px;
  word-break: break-word;

  @media (max-width: 1400px) {
    width: 100%;
    padding: 3vw;
  }
`;

export const CarouselContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  overflow-x: hidden;
`;

export const CardHeader = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
  display: flex;
  color: ${primary.light};
  text-transform: uppercase;
  margin-top: .5vh;
`;

export const CardDescription = styled.div`
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  color: ${secondary.main};
  margin-top: 1vh;
`;

export const CardText = styled.div`
  font-size: 16px;
  margin-left: 3px;
  color: #333333;
`;


export const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2vh;

  @media (max-width: 1400px) {
    flex-direction: column;
    margin-left: -1vw;
  }
`;

export const InfoTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: 1400px) {
    margin-top: .5vh;
  }
`;